
import { Route, Routes, } from "react-router-dom";
import Index from "./Pages/Index/Index";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import Categorias from "./Pages/Categorias/Categorias";
import AgregarCategoria from "./Pages/AgregarCategoria/AgregarCategoria";
import AgregarProducto from "./Pages/AgregarProducto/AgregarProducto";
import AgregarImagenesProductos from "./Pages/AgregarImagenesProductos/AgregarImagenesProductos";
import VerProducto from "./Pages/VerProducto/VerProducto";
import Carrito from "./Pages/CarritoCompras/CarritoCompras";
import AdminPedidos from "./Pages/AdminPedidos/AdminPedidos";
import CategoriaProductos from "./Pages/CategoriaProductos/CategoriaProductos";
import PerfilUser from "./Pages/PerfilUser/PerfilUser";
import ClientePedidos from "./Pages/ClientePedidos/ClientePedidos";
import AdminEditarDevolucion from "./Pages/AdminEditarDevolucion/AdminEditarDevolucion";
import SolicitudDevolucion from "./Pages/SolicitudDevolucionCliente/SolicitudDevolucion";
import Devoluciones from "./Pages/Politicas/Devoluciones";
import CancelacionReembolso from "./Pages/Politicas/CancelacionReembolso";
import Envios from "./Pages/Politicas/Envios";
import Garantia from "./Pages/Politicas/Garantias";
import Privacidad from "./Pages/Politicas/Privacidad";
import Terminos from "./Pages/Politicas/Terminos";
import EditarProducto from "./Pages/EditarProducto/EditarProducto";
import EditarCategoria from "./Pages/EditarCategoria/EditarCategoria";
import ProductosAgotadosInactivos from "./Pages/ProductosAgotadosInactivos/ProductosAgotadosInactivos";
import EditarPerfilUser from "./Pages/EditarPerfilUser/EditarPerfilUser";

function App() {
  return (

    <div className="App">
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/categorias" element={<Categorias />} />
        <Route path="/AgregarCategorias" element={<AgregarCategoria />} />
        <Route path="/AgregarProducto" element={<AgregarProducto />} />
        <Route path="/AgregarImagenesProductos/:id" element={<AgregarImagenesProductos />} />
        <Route path="/verProducto/:id" element={<VerProducto />} />
        <Route path="/carrito" element={<Carrito />} />
        <Route path="/AdminPedidos" element={<AdminPedidos />} />
        <Route path="/SolicitudDevoluciones/:id" element={<SolicitudDevolucion />} />
        <Route path="/ClientePedidos" element={<ClientePedidos />} />
        <Route path="/CategoriaProductos/:id" element={<CategoriaProductos />} />
        <Route path="/PerfilUser" element={<PerfilUser />} />
        <Route path="/AdminEditarDevolucion/:id" element={<AdminEditarDevolucion />} />
        <Route path="/politicas/Devoluciones" element={<Devoluciones />} />
        <Route path="/politicas/ReembolsosCancelacion" element={<CancelacionReembolso />} />
        <Route path="/politicas/Envios" element={<Envios />} />
        <Route path="/politicas/Garantias" element={<Garantia />} />
        <Route path="/politicas/Privacidad" element={<Privacidad />} />
        <Route path="/politicas/TerminosCondiciones" element={<Terminos />} />
        <Route path="/EditarProducto/:id" element={<EditarProducto />} />
        <Route path="/EditarCategoria/:id" element={<EditarCategoria/>} />
        <Route path="/ProductosAgotadosInactivos" element={<ProductosAgotadosInactivos/>} />
        <Route path="/PerfilUser/Editar" element={<EditarPerfilUser/>} />

      </Routes>
    </div>


  );
}

export default App;
